import React from 'react';
import PropTypes from 'prop-types';
import { Table, Form } from 'react-bootstrap';
import { I18n } from '../utils/I18n';

export default class SortTable extends React.Component {
  static propTypes = {
    Headers: PropTypes.array.isRequired,
    Rows: PropTypes.array.isRequired,
    DefaultVisibleColumn: PropTypes.array,

    HeadersStyle: PropTypes.array,
    HasCheckBox: PropTypes.bool,

  };

  constructor(props) {
    super(props);
    this.HeaderStyle = [];
    for (let i = 0; i < props.Headers.length; i++) {
      if (props.HeadersStyle && props.HeadersStyle.length > i) {
        this.HeaderStyle.push(props.HeadersStyle[i]);
      } else {
        this.HeaderStyle.push({});
      }
    }

    let defaultVisibleCol = props.DefaultVisibleColumn;
    if (defaultVisibleCol == null || defaultVisibleCol.length < props.Headers.length) {
      defaultVisibleCol = [];
      for (let i = defaultVisibleCol.length; i < props.Headers.length; i++) {
        defaultVisibleCol.push(true);
      }
    }

    this.state = {
      SortBy: 0,
      SortDESC: true,

      VisibleColumn: defaultVisibleCol,
      hoverVisible: [],
      hellovisible: false,

    };
    this.accountCheckBox = [];
    this.SortedRows = [];
  }

  updateRow (newRows) {
    this.SortedRows=newRows
  }

  getAccountCheckBox=()=>{
    return this.accountCheckBox;
  }

  deleteAccountCheckBox=()=>{ 
    //this.accountCheckBox=[];
    console.log("清除")
    for(let k in this.accountCheckBox){
      if(this.accountCheckBox[k])
      this.accountCheckBox[k].checked=false;
    }
  }


  toggleVisibleColumn(columnIndex) {
    let VisibleColumn = this.state.VisibleColumn;
    VisibleColumn[columnIndex] = !VisibleColumn[columnIndex];

    this.setState({
      VisibleColumn,
    });
  }

  render() {
    let headers = [];
    if (this.props.HasCheckBox) {
      headers.push(
        <th key={"h_ckb"} style={{ width: "35px" }}>
          <Form.Check type="checkbox" id="check_all" label="" custom />
        </th>
      );
    }
    for (let i = 0; i < this.props.Headers.length; i++) {
      if (this.state.VisibleColumn[i]) {
        headers.push(
          <th key={"h_" + i} style={this.HeaderStyle[i]} className={this.state.SortBy === i ? "text-primary" : ""} onClick={() => this.changeSort(i)}>
            <span>{this.props.Headers[i]}</span>
            <span className="float-right">{
              this.state.SortBy === i && !this.state.SortDESC ?
                "▲" : "▼"
            }</span>
          </th>
        );
      }
    }

    let rows = [];
    let hoverRow = [];
    let CheckRay=[];
    

    for (let i = 0; i < this.SortedRows.length; i++) {
      let cols = [];
      let data = this.SortedRows[i];
      CheckRay.push(false)

      if (this.props.HasCheckBox) {
        cols.push(
          <td key={"c_ckb_" + i}>
            <Form.Check type="checkbox" id={"c_ckb_" + i}
              ref={ref => this.accountCheckBox.push(ref)}

              label={""}
               name={data[0]} custom />
          </td>
        );

        hoverRow.push(false);
      }

      for (let j = 0; j < this.props.Headers.length; j++) {

        if (this.state.VisibleColumn[j] && j == 0) {
          cols.push(
            <td key={"c_" + i + "_" + j} onMouseEnter={() => {

              let n = [];
              for (let k = 0; k < this.SortedRows.length; k++) {
                if (k == i)
                  n.push(true);
                else
                  n.push(false);
              }
              this.setState({ hoverVisible: n });

            }}
              onMouseLeave={() => {
                let allfa = [];
                for (let w = 0; w < this.SortedRows.length; w++) {
                  allfa.push(false);
                }

                this.setState({ hoverVisible: allfa });
              }}
            >
              {data[j]}
              {
                this.state.hoverVisible[i] ?
                  <div className="row" style={{ marginLeft: "10%" }}>
                    <span className="text-primary" style={{ marginRight: "2%", marginLeft: "2%" }} onClick={() => { this.props.openEditModel(data[j]) }}>{I18n.t('global.edit')}</span>
                    <span> | </span>
                    <span className="text-primary" style={{ marginRight: "2%", marginLeft: "2%" }} onClick={() => { this.props.openDeleteModel(data[j]) }}>{I18n.t('global.delete')}</span>
                  </div>

                  : null
              }

            </td>
          );
        }

        if (this.state.VisibleColumn[j] && j != 0) {
          cols.push(
            <td key={"c_" + i + "_" + j}>
              {data[j]}
            </td>
          );
        }

      }
      rows.push(
        <tr key={"r_" + i} >
          {cols}
        </tr>
      );
    }

    return (
      <div style={{ height: "100%", overflowY: "auto" }}>
        <Table bordered size="sm">
          <thead>
            <tr style={{ backgroundImage: "url('/images/bar_bg.png')", backgroundSize: "100% 100%" }}>
              {headers}
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
    );
  }

  changeSort(columnIndex) {
    let sortdesc = true;
    if (this.state.SortBy === columnIndex) {
      sortdesc = !this.state.SortDESC;
    }

    this.SortRows(columnIndex, sortdesc);
  }

  SortRows(sortBy, sortDESC) {
    this.SortedRows = this.props.Rows;

    this.SortedRows.sort((a, b) => {
      let colA = a[sortBy];
      let colB = b[sortBy];

      while (typeof colA !== 'string') {
        colA = colA.props.children;
      }
      while (typeof colB !== 'string') {
        colB = colB.props.children;
      }

      if (sortDESC) {
        return colA < colB ? 1 : -1;
      }

      return colA > colB ? 1 : -1;
    });

    this.setState({
      SortBy: sortBy,
      SortDESC: sortDESC,
    });
  }
}